// FILE NOTE: Custom JS file created to not interfere with the theme's JS file. Also incase the theme is updated and theme JS get's overwritten this file will remain untouched.

const isMobile = window.innerWidth < 700;


// CLP VIEW ALL BUTTON
window.fetchGraphQL = async function fetchGraphQL(query, variables) {
  const response = await fetch('https://akubra.myshopify.com/api/2025-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'b7606b76d296ec78701d5efe4dc1ef19',
    },
    body: JSON.stringify({ query, variables })
  });

  const data = await response.json();
  return data
}

async function fetchProducts(collectionHandle, after = null) {

  const query = `
  query ($handle: String!, $after: String) {
    collectionByHandle(handle: $handle) {
      products(first: 250, after: $after) {
        nodes {
          title
          onlineStoreUrl
          images(first: 1) {
            nodes {
              originalSrc
            }
          }
          variants(first: 10) {
            nodes {
              price {
                amount
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }`;

  const variables = {
    handle: collectionHandle,
    after,
  };

  return fetchGraphQL(query, variables);
}

function createProductCard(product) {
  let productImage = product?.images?.nodes[0]?.originalSrc;
  return `
    <product-card class="product-card">
      <a href="${product?.onlineStoreUrl}" class="product-card__media">
        <img 
          src="${productImage}" 
          srcset="
            ${productImage}?width=320 320w,
            ${productImage}?width=480 480w,
            ${productImage}?width=768 768w,
            ${productImage}?width=1024 1024w
          "
          sizes="(max-width: 768px) 100vw, 50vw"
          alt="${product?.title}" 
          class="product-card__image"
        />      
      </a>
      <div class="product-card__info">
        <div class="v-stack w-full">
          <a href="${product?.onlineStoreUrl}" class="product-title text-xxs block w-full text-start text-gray-100 font-serif">
            ${product?.title}
          </a>
          <sale-price class="text-start text-gray-70 text-xxxxs">
            $${product?.variants?.nodes[0]?.price?.amount}
          </sale-price>
        </div>
      </div>
    </product-card>
  `;
}

function createEmptyProductCard() {
  return `
    <product-card class="product-card"></product-card>
  `;
}

async function getProductsFromCollection(collectionHandle) {
  let allProducts = [];
  let response = true;
  let afterCursor;

  while (response) {
    const result = await fetchProducts(collectionHandle, afterCursor);
    const products = result.data.collectionByHandle.products;
    allProducts.push(...products.nodes);

    response = products.pageInfo.hasNextPage;
    afterCursor = products.pageInfo.endCursor;
  }

  const productList = document.querySelector('.product-list');
  if (productList) {
    productList.innerHTML = '';

    for (let i = 0; i < allProducts.length; i++) {
      const product = allProducts[i];
      productList.insertAdjacentHTML('beforeend', createProductCard(product));
    }

    let viewAllBtn = document.querySelector('.pagination-view-all__btn');
    viewAllBtn.classList.add('hidden')
    viewAllBtn.classList.remove('flex')
  }

  // Below we are adding empty product cards to make sure the layout is correct, if missing products in a row the grid lines can't be calculated correctly (technical limitation)
  const totalProducts = allProducts.length
  const itemsPerRow = window.innerWidth >= 1000 ? 3 : window.innerWidth >= 700 ? 2 : 1;
  const remainder = totalProducts % itemsPerRow;
  const missingItems = remainder === 0 ? 0 : itemsPerRow - remainder;

  if (missingItems > 0) {
    for (let i = 0; i < missingItems; i++) {
      productList.insertAdjacentHTML('beforeend', createEmptyProductCard());
    }
  }
}


/*
  RICH TEXT EDITOR - ADDING CUSTOM STYLES
  - This is used to replace text surrounded by square brackets with a span element with a class of font-cursive

  To use this, paste the below code into the liquid file where you want to use it and update the querySelectorAll to target the correct element.

  <script>
    document.addEventListener('DOMContentLoaded', function() {
      var element = document.querySelectorAll(".slideshow__slide-content .section-title")
      replaceText(element);
    });
  </script>
*/

function replaceText(elements) {
  if (!elements || elements.length === 0) return;

  elements.forEach((element) => {
    let isH1 = element.tagName.toLowerCase() === 'h1' || element.classList.contains('h1');

    element.innerHTML = element.innerHTML.replace(/\[(.*?)\]/g, (match, originalWord) => {
      let spanClass = "font-cursive font-350";
      if (isH1) {
        spanClass += " lowercase";
      }

      return `<span class="${spanClass}">${originalWord}</span>`;
    });
  });
}



// Utilised to adjust the drawers position from the top of the page, considers announcement bar and header sizes 
function adjustDrawerPosition(buttonSelector, shadowHostId) {
  const button = document.querySelector(buttonSelector);

  button.addEventListener('click', () => {
    let headerHeight = 114;
    let announcementHeight = 60;

    const shadowHost = document.querySelector(shadowHostId);
    const shadowRoot = shadowHost.shadowRoot;
    const baseDiv = shadowRoot.querySelector('div[part="base"]');

    const distanceFromTop = window.scrollY;
    const windowWidth = window.innerWidth;

    // Adjust heights based on the window width
    if (windowWidth > 700 && windowWidth < 1000) {
      headerHeight = 68;
    } else if (windowWidth < 700) {
      headerHeight = 54;
      announcementHeight = 50;
    }

    // Set the top position based on scroll distance
    if (distanceFromTop >= announcementHeight) {
      baseDiv.style.top = `${headerHeight}px`;
    } else {
      baseDiv.style.top = `${headerHeight + (announcementHeight - distanceFromTop)}px`;
    }
  });
}


//  FIND IN STORE DRAWER

const storeAvailabilityQuery = `
query getStoreAvailability($variantId: ID!) {
  node(id: $variantId) {
    ... on ProductVariant {
      storeAvailability(first: 5) {
        edges {
          node {
            available
            location {
              name
            }
          }
        }
      }
    }
  }
}`;

const encodeVariantId = (variantId) => btoa(`gid://shopify/ProductVariant/${variantId}`);

window.findSelectedRadio = function findSelectedRadio(radioButtons, selectedSize) {
  return Array.from(radioButtons).find(
    (button) => button.getAttribute("data-option-value") === selectedSize
  );
}

window.updateStoreAvailability = async function updateStoreAvailability(selectedVariantId, fisDrawer) {
  const encodedVariantId = encodeVariantId(selectedVariantId);
  const variables = { variantId: encodedVariantId };

  try {
    const newStoreData = await fetchGraphQL(storeAvailabilityQuery, variables);
    const accordions = fisDrawer.querySelectorAll(".accordion");

    newStoreData?.data?.node?.storeAvailability?.edges.forEach((storeData) => {
      const { name: locationName } = storeData.node.location;
      const availability = storeData.node.available;

      accordions.forEach((accordion) => {
        const locationNameElement = accordion.querySelector(".fis-drawer__store-title");

        if (locationNameElement?.textContent.trim() === locationName) {
          accordion.querySelector(".fis-drawer__available")?.classList.toggle("hidden", !availability);
          accordion.querySelector(".fis-drawer__available")?.classList.toggle("flex", availability);

          accordion.querySelector(".fis-drawer__not-available")?.classList.toggle("hidden", availability);
          accordion.querySelector(".fis-drawer__not-available")?.classList.toggle("flex", !availability);

        }
      });
    });
  } catch (error) {
    console.error("Error fetching store availability:", error);
  }
}

// Will update both Desktop and Mobile size selectors
window.handleRadioChange = function handleRadioChange(event, fisDrawer) {
  const selectedLabel = fisDrawer.querySelectorAll(`label[for="${event.target.id}"]`)
  const selectedInputs = fisDrawer.querySelectorAll(`input[value="${event.target.value}"]`);

  fisDrawer.querySelectorAll("label").forEach((label) => label.classList.remove("selected"));

  selectedLabel.forEach((label) => label.classList.add("selected"));
  isMobile ? selectedInputs[1].click() : selectedInputs[0].click()

  // Update store availability based on selected variant
  window.updateStoreAvailability(event.target.dataset.variantId, fisDrawer);
}

window.handleDrawerClose = function handleDrawerClose(fisDrawer) {
  let selectedRadio = isMobile ? fisDrawer.querySelectorAll('.fis-drawer__mobile-size-variants input[type="radio"][name="size"]:checked') : fisDrawer.querySelectorAll('.fis-drawer__desktop-size-variants input[type="radio"][name="size"]:checked');
  selectedRadio = selectedRadio.length > 0 ? selectedRadio[0] : null;
  if (!selectedRadio) return;

  const selectedValue = selectedRadio.value || selectedRadio.dataset.value;
  const container = document.querySelector(".product-info__block-item .variant-picker__option-values");
  if (!container || !selectedValue) return;

  const relatedInput = container.querySelector(`input[value="${selectedValue}"]`);
  if (relatedInput) {
    relatedInput.click();
  }
}

// Function that runs on page load to select the radio button
window.selectRadioOnLoad = function selectRadioOnLoad(fisDrawer, productVariant) {
  const selectedSize = productVariant.title;
  const radioButtons = isMobile ? fisDrawer.querySelectorAll('.fis-drawer__mobile-size-variants input[type="radio"][name="size"]') : fisDrawer.querySelectorAll('.fis-drawer__desktop-size-variants input[type="radio"][name="size"]');
  if (radioButtons.length === 0) return;

  const selectedRadio = findSelectedRadio(radioButtons, selectedSize);
  if (selectedRadio) {
    selectedRadio.click();
  }
}

window.setupRadioButtons = function setupRadioButtons(fisDrawer) {
  const radioButtons = fisDrawer.querySelectorAll('input[type="radio"][name="size"]')
  radioButtons.forEach((button) =>
    button.addEventListener("change", (event) => handleRadioChange(event, fisDrawer))
  );
}

window.setupDrawerClose = function setupDrawerClose(fisDrawer) {
  const shadowRoot = fisDrawer?.shadowRoot;

  if (!shadowRoot) return;

  const targetElement = shadowRoot.querySelector('[part="overlay"]');
  if (targetElement) {
    targetElement.addEventListener("click", () => handleDrawerClose(fisDrawer));
  }


  const defaultCloseButton = shadowRoot.querySelector("dialog-close-button")
  if (defaultCloseButton) {
    defaultCloseButton.style.display = "none";
  }

  const closeButton = fisDrawer.querySelector(".drawer-close-button");
  if (closeButton) {
    closeButton.addEventListener("click", () => handleDrawerClose(fisDrawer));
  }
}

// Model toggle
window.modelToggleValue = function modelToggleValue() {
  // Get URL parameters
  const url = new URL(window.location);
  const urlParams = url.searchParams;
  const toggleValue = urlParams.get("toggle");
  const expectedToggleValues = ["female", "male", "product"]

  // Store toggle value from URL if it exists in the expected toggle array
  if (expectedToggleValues.includes(toggleValue)) {
    localStorage.setItem("modelToggleOption", toggleValue);
  }
}

// Remove toggle parameter if user selects their own option
window.removeUrlToggleParam = function removeUrlToggleParam() {
  const url = new URL(window.location);
  const urlParams = url.searchParams;

  if (urlParams.has("toggle")) {
    urlParams.delete("toggle");
    window.history.replaceState({}, document.title, `${url.pathname}${url.search.toString()}`);
  }
}